import { render, staticRenderFns } from "./base-form.vue?vue&type=template&id=dcc40ecc&scoped=true"
import script from "./base-form.vue?vue&type=script&lang=js"
export * from "./base-form.vue?vue&type=script&lang=js"
import style0 from "./base-form.vue?vue&type=style&index=0&id=dcc40ecc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcc40ecc",
  null
  
)

export default component.exports